<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Kesilmeyen Faturalar</v-toolbar-title>
      <v-spacer />
      <v-btn flat color="primary" to="/admin/invoice-labor">İşçilik Tablosu</v-btn>
      <v-btn icon @click="getir">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="px-3">
      <v-alert
        v-for="t in tenants"
        :key="t.tenantId"
        :value="true"
        :type="t.active ? 'warning' : 'info'"
        outline
        class="mb-2"
      >
        <b>{{ t.tenantName }}:</b>
        <span v-if="t.active">
          anahtar açık. Aşağıdaki {{ sayi(t.tenantId) }} siparişin faturası, yanında yazan sebep giderilene kadar kesilmiyor.
          Sebep giderildiğinde sipariş listeden düşer, faturası birkaç dakika içinde kendiliğinden kesilir.
        </span>
        <span v-else>
          anahtar kapalı, faturalar eski formülle kesiliyor. Aşağıdaki {{ sayi(t.tenantId) }} sipariş,
          anahtar açılırsa bekleyecek olanlardır.
        </span>
        <v-btn v-if="sayi(t.tenantId) && t.tenantId === 1" small flat color="primary" @click="hepsiniAc(t.tenantId)">
          Bekleyen bütün ürünleri tabloda aç
        </v-btn>
      </v-alert>
    </div>

    <v-data-table
      :headers="headers"
      :items="orders"
      item-key="id"
      :loading="yukleniyor"
      :rows-per-page-items="[50, 100, { text: 'Hepsi', value: -1 }]"
      class="elevation-1 mx-3"
    >
      <template v-slot:items="props">
        <td>
          <v-chip small :color="aktifMi(props.item.tenantId) ? 'orange' : 'grey'" text-color="white">
            {{ props.item.tenantName }}
          </v-chip>
        </td>
        <td>{{ pazaryeri(props.item.mpId) }}</td>
        <td>{{ props.item.orderNumber }}</td>
        <td>{{ tarih(props.item.orderDate) }}</td>
        <td>{{ props.item.customer }}</td>
        <td class="text-xs-right">{{ para(props.item.total) }} ₺</td>
        <td class="py-2">
          <div v-for="i in props.item.items" :key="i.productId" class="mb-1">
            <b>{{ i.productName }}</b>
            <span class="grey--text"> · {{ i.sku }} · {{ i.quantity }} adet</span>
            <div class="red--text">{{ i.reason }}</div>
          </div>
        </td>
        <td>
          <v-btn v-if="props.item.tenantId === 1" small color="primary" @click="iscilikGir(props.item)">Tabloda aç</v-btn>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center pa-3">Bekleyen sipariş yok.</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import invoiceLaborApi from "@/api/invoiceLabor";

const PAZARYERLERI = { 1: "Hepsiburada", 2: "Alışgidiş", 3: "Trendyol", 4: "Idefix", 5: "Idia", 6: "n11" };

export default {
  data() {
    return {
      tenants: [],
      orders: [],
      yukleniyor: false,
      headers: [
        { text: "Şirket", value: "tenantName" },
        { text: "Pazaryeri", value: "mpId" },
        { text: "Sipariş No", value: "orderNumber" },
        { text: "Sipariş Tarihi", value: "orderDate" },
        { text: "Müşteri", value: "customer" },
        { text: "Tutar", value: "total", align: "right" },
        { text: "Neden kesilmedi", value: "items", sortable: false },
        { text: "", value: "islem", sortable: false }
      ]
    };
  },
  created() {
    this.getir();
  },
  methods: {
    async getir() {
      this.yukleniyor = true;
      try {
        const res = await invoiceLaborApi.held();
        this.tenants = res.data.tenants;
        this.orders = res.data.orders;
      } catch (e) {
        this.$store.commit("SET_MESSAGE", "Bekleyen faturalar okunamadı.");
      } finally {
        this.yukleniyor = false;
      }
    },
    sayi(tenantId) {
      return this.orders.filter(o => o.tenantId === tenantId).length;
    },
    aktifMi(tenantId) {
      const t = this.tenants.find(x => x.tenantId === tenantId);
      return t && t.active;
    },
    pazaryeri(mpId) {
      return PAZARYERLERI[mpId] || mpId;
    },
    tarih(v) {
      return v ? new Date(v).toLocaleString("tr-TR") : "";
    },
    para(n) {
      return Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    iscilikGir(order) {
      this.tablodaAc(order.tenantId, order.items.map(i => i.productId));
    },
    hepsiniAc(tenantId) {
      const ids = this.orders.filter(o => o.tenantId === tenantId).flatMap(o => o.items.map(i => i.productId));
      this.tablodaAc(tenantId, ids);
    },
    tablodaAc(tenantId, ids) {
      this.$router.push({ path: "/admin/invoice-labor", query: { tenantId, ids: [...new Set(ids)].join(",") } });
    }
  }
};
</script>
